module.exports = __webpack_public_path__ + "static/media/light_icn_map_fermata_ls_capolinea.7958b9dd.svg";